import Segment from '../shared/segment';
import NavLink from '../shared/buttons/nav-link';
import { useUser } from '../../hooks/react-query/use-user';

function Home() {
  const { isError: withoutUser } = useUser();
  return (
    <Segment textAlign='justify' className='p-8 leading-8'>
      <h1 data-testid='heading' className='mt-4 mb-8 text-center text-lg font-medium'>
        سامانه آزمون‌های مدمشاور
      </h1>
      <div data-testid='content'>
        <p>
          <span>به سامانه </span>
          <span className='font-medium'>آزمون‌های مدمشاور</span>
          <span> خوش آمدید.</span>
        </p>
        <p>
          در این سامانه امکان شرکت در آزمون های آمادگی دستیاری و پیش کارورزی به صورت آنلاین برای شما
          فراهم خواهد بود.
        </p>
        <p>
          سوالات به صورت ترکیبی از سوالات استاندارد آزمون های سال های گذشته و همچنین سوالات تالیفی
          توسط رتبه های برتر آزمون دستیاری خواهد بود.
        </p>
        <p className='text-red-500'>
          <span className='font-medium'>توجه: </span>
          شرکت در آزمون های گروه مدمشاور، برای داوطلبان گروه مشاوره خصوصی رایگان است و در صورت
          پرداخت مبلغ برای آزمون‌ها، امکان عودت مبلغ وجود نخواهد داشت.
        </p>
      </div>
      <div data-testid='start' className='mt-8 flex flex-col gap-1'>
        {withoutUser && (
          <div className='flex flex-row justify-center gap-2'>
            <NavLink
              outline
              to='/login'
              size='2xl'
              color='blue'
              colorWeight={500}
              content='ورود'
              className='mx-auto'
            />
            <NavLink
              outline
              to='/register'
              size='2xl'
              color='green'
              colorWeight={500}
              content='ثبت نام'
              className='mx-auto'
            />
          </div>
        )}
        <NavLink
          outline
          to='/terms-and-conditions'
          size='lg'
          color='rose'
          colorWeight={400}
          content='شرایط و قوانین'
          className='mx-auto my-4'
        />
      </div>
    </Segment>
  );
}

export default Home;
